import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../services/master/MasterService'
import { useNavigate } from 'react-router-dom'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../components/Card'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import { FaChevronCircleLeft, FaEraser, FaSave } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import MasterIkanModal from './MasterIkanModal'
import MasterIkanHsModal from './MasterIkanHsModal'
import SweetAlert from 'react-bootstrap-sweetalert'

const MasterIkanAddEdit = () => {
    let masterService = useMemo(() => new MasterService(), [])
    let navigate = useNavigate()

    const [valueIdIkanTrader, setValueIdIkanTrader] = useState(null)
    const [valueIdIkan, setValueIdIkan] = useState(null)
    const [valueNmDagang, setValueNmDagang] = useState(null)
    const [valueNmUmum, setValueNmUmum] = useState(null)
    const [valueNmLatin, setValueNmLatin] = useState(null)
    const [valueKonsumsiOpt, setValueKonsumsiOpt] = useState(null)
    const [valueTawarOpt, setValueTawarOpt] = useState(null)
    const [valueHidupOpt, setValueHidupOpt] = useState(null)
    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0);
    const [valueBentukOpt, setValueBentukOpt] = useState(null)
    const [valueHscode, setValueHscode] = useState(null)
    const [valueHsCodeUraian, setValueHsCodeUraian] = useState(null)
    const [valueKelompokIkanOpt, setValueKelompokIkanOpt] = useState(null)
    const [valueSatuanOpt, setValueSatuanOpt] = useState(null)

    const [disabledForm, setDisableForm] = useState(false)

    useEffect(() => {
        let dataIkanExisting = JSON.parse(localStorage.getItem('dataIkanStorage'))
        console.log(dataIkanExisting)
        if (!dataIkanExisting) return
        const fetchAllData = async () => {
            try {
                setValueIdIkanTrader(dataIkanExisting.idIkanTrader)
                setValueIdIkan(dataIkanExisting.idIkan)
                setValueNmDagang(dataIkanExisting.nmDagang)
                setValueNmUmum(dataIkanExisting.nmUmum)
                setValueNmLatin(dataIkanExisting.nmLatin)

                const optionKonsumsi = [{ value: 'K', label: 'Konsumsi' }, { value: 'N', label: 'Non Konsumsi' }]
                setValueKonsumsiOpt(optionKonsumsi.find(option => option.value = dataIkanExisting.konsumsi))

                const optionTawar = [{ value: 'L', label: 'Laut' }, { value: 'T', label: 'Tawar' }]
                setValueTawarOpt(optionTawar.find(option => option.value = dataIkanExisting.tawar))

                const optionHidup = [{ value: '1', label: 'Hidup' }, { value: '2', label: 'Non Hidup' }]
                setValueHidupOpt(optionHidup.find(option => option.value = dataIkanExisting.hidup))

                const resBentuk = await masterService.getBentukIkanById(dataIkanExisting.bentuk)
                setValueBentukOpt(resBentuk.data)

                const resKelompok = await masterService.getKelompokIkan(dataIkanExisting.idKelIkan)
                setValueKelompokIkanOpt(resKelompok.data)

                const resSatuan = await masterService.getSatuanByKd(dataIkanExisting.kdSatuan)
                setValueSatuanOpt(resSatuan.data)

                setValueHscode(dataIkanExisting.hscode)

                const resHs = await masterService.getHsCode(dataIkanExisting.hscode)
                setValueHsCodeUraian(resHs.data.uraianId)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [masterService])

    async function loadOptionKonsumsi(search, loadedOption, { page }) {
        const options = [
            {
                value: 'K',
                label: 'Konsumsi'
            },
            {
                value: 'N',
                label: 'Non Konsumsi'
            }
        ]
        return {
            options: options,
        }
    }

    async function loadOptionTawar(search, loadedOption, { page }) {
        const options = [
            {
                value: 'L',
                label: 'Laut'
            },
            {
                value: 'T',
                label: 'Tawar'
            }
        ]
        return {
            options: options,
        }
    }

    async function loadOptionHidup(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Hidup'
            },
            {
                value: '2',
                label: 'Non Hidup'
            }
        ]
        return {
            options: options,
        }
    }

    async function loadOptionBentuk(search, loadedOption, { page = 1 }) {
        const response = await masterService.listBentukIkan(null, null, valueHidupOpt.value, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionKelompokIkan(search, loadedOption, {page = 1}) {
        const response = await masterService.listKelompokIkan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionSatuan(search, loadedOption, {page = 1}) {
        const response = await masterService.listSatuan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeNmDagang = e => {
        setValueNmDagang(e.target.value)
    }

    const onChangeNmUmum = e => {
        setValueNmUmum(e.target.value)
    }

    const onChangeNmLatin = e => {
        setValueNmLatin(e.target.value)
    }

    const onChangeKonsumsi = e => {
        setValueKonsumsiOpt(e)
    }

    const onChangeTawar = e => {
        setValueTawarOpt(e)
    }

    const onChangeHidup = e => {
        setKeyForSecondSelect(prevKey => prevKey + 1)
        setValueHidupOpt(e)
    }

    const onChangeBentuk = e => {
        setValueBentukOpt(e)
    }

    const onChangeKelompokIkan = e => {
        setValueKelompokIkanOpt(e)
    }

    const onChangeSatuan = e => {
        setValueSatuanOpt(e)
    }

    const handleClickResetData = () => {
        setValueIdIkanTrader('')
        setValueIdIkan('')
        setValueNmDagang('')
        setValueNmUmum('')
        setValueNmLatin('')
        setValueHscode('')
        setValueHsCodeUraian('')
        setValueKonsumsiOpt(null)
        setValueTawarOpt(null)
        setValueHidupOpt(null)
        setValueBentukOpt(null)
        setValueKelompokIkanOpt(null)
        setValueSatuanOpt(null)
        setDisableForm(false)
    }

    const handleClickBatal = () => {
        localStorage.removeItem("dataIkanStorage")
        navigate('/master/ikan')
    }

    const [showIkanModal, setShowIkanModal] = useState(false)
    const handleClickCariIkan = () => {
        setShowIkanModal(true)
    }
    const handleCloseIkanModal = async (row) => {
        setValueIdIkan(row.idIkan)
        setValueNmDagang(row.nmDagang)
        setValueNmUmum(row.nmUmum)
        setValueNmLatin(row.nmLatin)

        const optionKonsumsi = [{ value: 'K', label: 'Konsumsi' }, { value: 'N', label: 'Non Konsumsi' }]
        setValueKonsumsiOpt(optionKonsumsi.find(option => option.value = row.konsumsi))

        const optionTawar = [{ value: 'L', label: 'Laut' }, { value: 'T', label: 'Tawar' }]
        setValueTawarOpt(optionTawar.find(option => option.value = row.tawar))

        const optionHidup = [{ value: '1', label: 'Hidup' }, { value: '2', label: 'Non Hidup' }]
        setValueHidupOpt(optionHidup.find(option => option.value = row.hidup))

        const resBentuk = await masterService.getBentukIkanById(row.bentuk)
        setValueBentukOpt(resBentuk.data)

        const resKelompok = await masterService.getKelompokIkan(row.idKelIkan)
        setValueKelompokIkanOpt(resKelompok.data)

        const resSatuan = await masterService.getSatuanByKd(row.kdSatuan)
        setValueSatuanOpt(resSatuan.data)

        setValueHscode(row.hscode)

        const resHs = await masterService.getHsCode(row.hscode)
        setValueHsCodeUraian(resHs.data.uraianId)

        setShowIkanModal(false)
    }

    const [showHsModal, setShowHsModal] = useState(false)
    const handleClickCariHs = () => {
        setShowHsModal(true)
    }
    const handleCloseHsModal = (rowHs) => {
        setValueHscode(rowHs.kodeHs)
        setValueHsCodeUraian(rowHs.uraianId)
        setShowHsModal(false)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpanIkan, setShowConfirmSimpanIkan] = useState(false)
    const handleCloseConfirmSimpanIkan = () => setShowConfirmSimpanIkan(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleClickSimpan = () => {
        setShowConfirmSimpanIkan(true)
    }

    const handleClickProsesSimpan = async () => {
        try {
            setLoadingSave(true)
            let dataIkanExisting = JSON.parse(localStorage.getItem("dataIkanStorage"))
            console.log(dataIkanExisting)
            let jsonIkan = {
                ...dataIkanExisting,
                idIkanTrader: valueIdIkanTrader !== null ? valueIdIkanTrader : 0,
                idIkan: valueIdIkan !== null ? valueIdIkan : 0,
                nmDagang: valueNmDagang,
                nmUmum: valueNmUmum,
                nmLatin: valueNmLatin,
                konsumsi: valueKonsumsiOpt.value,
                tawar: valueTawarOpt.value,
                hidup: valueHidupOpt.value,
                hscode: valueHscode,
                bentuk: valueBentukOpt.kdBentuk,
                userId: localStorage.getItem('userId'),
                kodeTrader: Number(localStorage.getItem('kodeTrader')),
                idKelIkan: valueKelompokIkanOpt.idKelIkan,
                kdSatuan: valueSatuanOpt.kdSatuan,
                uraianSatuan: valueSatuanOpt.uraianSatuan
            }
            console.log(jsonIkan)
            const resSimpanIkan = await masterService.addIkanTrader(jsonIkan)
            if (resSimpanIkan.data.kode === '200') {
                setShowSimpanSuccess(true)
                setShowConfirmSimpanIkan(false)
            } else {
                setShowSimpanFailed(true)
                setShowConfirmSimpanIkan(false)
            }
            setLoadingSave(false)
        } catch (error) {
            setLoadingSave(false)
            setShowSimpanFailed(true)
            setShowConfirmSimpanIkan(false)
        }
    }

    const handleCloseSimpanSuccess = () => {
        setLoadingSave(false)
        setShowSimpanSuccess(false)
        localStorage.removeItem("dataIkanStorage")
        navigate('/master/ikan')
    }

    const handleCloseSimpanFailed = () => {
        setLoadingSave(false)
        setShowSimpanFailed(false)
        localStorage.removeItem("dataIkanStorage")
        navigate('/master/ikan')
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h5 className="card-title">{localStorage.getItem("dataIkanStorage") !== null ? 'Ubah' : 'Tambah'}  Master Ikan</h5>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Dagang</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control type="text" placeholder="Nama Dagang" className="form-control-sm" value={valueNmDagang} onChange={onChangeNmDagang} disabled={disabledForm} />
                                                </Col>
                                                <Col sm="1">
                                                    <Button color='outline-primary' size='sm' onClick={() => handleClickCariIkan()}><FaMagnifyingGlass /></Button>
                                                </Col>
                                                <Col sm="4">
                                                    <small>*) Silahkan klik untuk mencari seluruh Master Ikan </small>
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Umum</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control type='text' placeholder="Nama Umum" className="form-control-sm" value={valueNmUmum} onChange={onChangeNmUmum} disabled={disabledForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Latin</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control type='text' placeholder="Nama Latin" className="form-control-sm" value={valueNmLatin} onChange={onChangeNmLatin} disabled={disabledForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Konsumsi</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionKonsumsi}
                                                        value={valueKonsumsiOpt}
                                                        getOptionLabel={(option) => option.value + ' - ' + option.label}
                                                        getOptionValue={(option) => option.value}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeKonsumsi}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tawar</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionTawar}
                                                        value={valueTawarOpt}
                                                        getOptionLabel={(option) => option.value + ' - ' + option.label}
                                                        getOptionValue={(option) => option.value}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeTawar}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hidup</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionHidup}
                                                        value={valueHidupOpt}
                                                        getOptionLabel={(option) => option.value + ' - ' + option.label}
                                                        getOptionValue={(option) => option.value}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeHidup}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Bentuk</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        key={keyForSecondSelect}
                                                        loadOptions={loadOptionBentuk}
                                                        value={valueBentukOpt}
                                                        getOptionLabel={(option) => option.ketBentuk}
                                                        getOptionValue={(option) => option.kdBentuk}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeBentuk}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Satuan</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionSatuan}
                                                        value={valueSatuanOpt}
                                                        getOptionLabel={(option) => option.kdSatuan + ' - ' + option.uraianSatuan}
                                                        getOptionValue={(option) => option.kdSatuan}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeSatuan}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kelompok Ikan</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionKelompokIkan}
                                                        value={valueKelompokIkanOpt}
                                                        getOptionLabel={(option) => option.idKelIkan + ' - ' + option.nmKelIkan}
                                                        getOptionValue={(option) => option.idKelIkan}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeKelompokIkan}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">HS</Form.Label>
                                                <Col sm="2">
                                                    <Form.Control type="text" placeholder="Hs Code" className="form-control-sm" value={valueHscode} disabled />
                                                </Col>
                                                <Col sm="1">
                                                    <Button color='outline-primary' size='sm' onClick={() => handleClickCariHs()} disabled={disabledForm}><FaMagnifyingGlass /></Button>
                                                </Col>
                                                <Col sm="6">
                                                    <Form.Control type="text" placeholder="Uraian" className="form-control-sm" value={valueHsCodeUraian} disabled />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" size='sm' onClick={() => handleClickSimpan()}><FaSave /> Simpan</Button>{' '}
                                <Button variant="warning" size='sm' onClick={() => handleClickResetData()}><FaEraser /> Reset</Button>{' '}
                                <Button variant="danger" size='sm' onClick={() => handleClickBatal()}>
                                    <FaChevronCircleLeft /> Kembali
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
                <MasterIkanModal showIkanModal={showIkanModal} handleCloseIkanModal={handleCloseIkanModal} setDisableForm={setDisableForm} />
                <MasterIkanHsModal showHsModal={showHsModal} handleCloseHsModal={handleCloseHsModal}/>
                {
                    showConfirmSimpanIkan &&
                    <SweetAlert
                        title="Simpan Data Ikan"
                        warning
                        showCancel
                        confirmBtnText={
                            loadingSave ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Proses Simpan...
                                </>
                            ) : (
                                "Simpan"
                            )
                        }
                        confirmBtnBsStyle="primary"
                        cancelBtnText="Batal"
                        cancelBtnBsStyle="secondary"
                        onConfirm={handleClickProsesSimpan}
                        onCancel={handleCloseConfirmSimpanIkan}
                        focusCancelBtn
                        btnSize="sm"
                        disabled={loadingSave}
                        reverseButtons={true}
                    >
                        {loadingSave && (
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                            </div>
                        )}
                    </SweetAlert>
                }
                {
                    showSimpanSuccess &&
                    <SweetAlert
                        success
                        title="Simpan Data Ikan Berhasil"
                        onConfirm={handleCloseSimpanSuccess}
                        btnSize="sm"
                    />
                }
                {
                    showSimpanFailed &&
                    <SweetAlert
                        danger
                        title="Simpan Data Ikan Gagal"
                        onConfirm={handleCloseSimpanFailed}
                        btnSize="sm"
                        timeout={2000}
                    />
                }
            </div>
        </>
    )
}

export default MasterIkanAddEdit